import { useQueryParams } from '@calendly/hooks';
import { buildQuery } from '@calendly/http-tools';
import { PaginationFooter } from '@calendly/ui/components/pagination-footer';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
const wrapperCss = "w9s8jlt";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const Pagination = ({
  pagination
}) => {
  const history = useHistory();
  const queryParams = useQueryParams();
  const {
    nextPage,
    prevPage,
    currentPage,
    limitValue: pageSize,
    totalCount,
    totalPages
  } = pagination;
  if (totalPages === 1) {
    return null;
  }
  const onPageChange = page => {
    if (page === 1) {
      const modifiedParams = {
        ...queryParams
      };
      delete modifiedParams.page;
      history.push({
        search: buildQuery(modifiedParams)
      });
    } else {
      history.push({
        search: buildQuery({
          ...queryParams,
          page
        })
      });
    }
  };
  const onPageSizeChange = newPageSize => {
    if (newPageSize === 20) {
      const modifiedParams = {
        ...queryParams
      };
      delete modifiedParams.page_size;
      delete modifiedParams.page;
      history.push({
        search: buildQuery(modifiedParams)
      });
    } else {
      const modifiedParams = {
        ...queryParams
      };
      delete modifiedParams.page;
      history.push({
        search: buildQuery({
          ...modifiedParams,
          page_size: newPageSize
        })
      });
    }
  };
  return <Wrapper>
      <PaginationFooter currentPage={currentPage} onNextClick={nextPage ? () => onPageChange(nextPage) : undefined} onPreviousClick={prevPage ? () => onPageChange(prevPage) : undefined} onPageSizeChange={onPageSizeChange} pageSize={pageSize} totalCount={totalCount} />
    </Wrapper>;
};

require("./pagination.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pagination.js");